import React from 'react';
import Home from './pages/Home';
import { CssBaseline } from '@mui/material';

export default function App() {
  return (
    <>
      <CssBaseline />
      <Home />
    </>
  );
}
